var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"relative flex justify-center",style:({ height: '20px' })},[_c('progress',{staticClass:"progress is-medium is-primary absolute",style:({ left: 0 }),attrs:{"max":_vm.max,"title":(_vm.value / _vm.max)},domProps:{"value":_vm.value || 0}})])
}
var staticRenderFns = []

export { render, staticRenderFns }